import * as React from "react";
import {Layout, Menu, Icon} from "antd";

import"./styles.less";

interface Props {
  isLoggedIn: boolean;
  logout: () => void;
}

export const Header: React.SFC<Props> = props => {
  const items = props.isLoggedIn ?
    <Menu.Item key="logout"><Icon type="logout" />Log out</Menu.Item> :
    null;

  const handleClick = (event: any) => {
    if (event.key === "logout")
      props.logout();
  };

  return (
    <Layout.Header>
      <div className="header-logo">
        Cybersanta.com
      </div>

      <div className="menu">
        <Menu
          mode="horizontal"
          onClick={handleClick}
        >
          {items}
        </Menu>
      </div>
    </Layout.Header>
  );
};



// WEBPACK FOOTER //
// ./src/components/header/index.tsx